import $ from 'jquery';

const addToCart = () => {
  const radio = $('.js-attribute-option');
  const form = $('form.variations_form');
  const inputVariation = $('input[name="variation_id"]');

  if (radio.length) {
    radio.on('change', ev => {
      const variationId = ev.target.getAttribute('data-variation-id');
      inputVariation
        .attr('value', variationId)
        .prop('value', variationId)
        .val(variationId);
      form.trigger('submit');
    });
  }
};
export default addToCart;



// WEBPACK FOOTER //
// ./src/scripts/modules/add-to-cart.js